/* Kraft & Kitchen — Editorial 2026 interactions
   Scroll reveal, sticky-header effect, mobile drawer, PDP gallery stack.
   Zero dependencies. Fires on DOMContentLoaded, respects prefers-reduced-motion. */

(function () {
  'use strict';

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Sticky header shadow when scrolled */
    var header = document.querySelector('.ed-header');
    if (header) {
      var onScroll = function () {
        if (window.scrollY > 8) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Mobile drawer */
    var burger = document.querySelector('.ed-header__burger');
    var drawer = document.querySelector('.ed-mobile-drawer');
    var scrim = document.querySelector('.ed-mobile-drawer__scrim');
    var close = document.querySelector('.ed-mobile-drawer__close');
    function openDrawer() { if (drawer) drawer.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-open'); document.body.style.overflow = ''; }
    if (burger) burger.addEventListener('click', openDrawer);
    if (close) close.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);

    /* Scroll reveal */
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    }

    /* PDP qty +/- */
    document.querySelectorAll('.ed-pdp__qty').forEach(function (qty) {
      var input = qty.querySelector('input');
      if (!input) return;
      qty.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var cur = parseInt(input.value || '1', 10);
          if (btn.dataset.act === 'dec') input.value = Math.max(1, cur - 1);
          if (btn.dataset.act === 'inc') input.value = cur + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* PDP variant swatch click — set hidden variant id + price refresh
       Works with both modern product form and the legacy theme's form hooks. */
    var variantSelect = document.querySelector('select[name="id"]');
    document.querySelectorAll('.ed-pdp__swatch').forEach(function (s) {
      s.addEventListener('click', function () {
        document.querySelectorAll('.ed-pdp__swatch[data-group="' + s.dataset.group + '"]').forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
        var vid = s.dataset.variantId;
        if (vid && variantSelect) {
          variantSelect.value = vid;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    /* Category card hover — preload secondary image if any */
    document.querySelectorAll('.ed-card').forEach(function (card) {
      var sec = card.querySelector('img.secondary');
      if (!sec) return;
      card.addEventListener('pointerenter', function () {
        if (sec.getAttribute('loading') === 'lazy') sec.setAttribute('loading', 'eager');
      }, { once: true });
    });

    /* Smooth scroll for in-page anchors */
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      var hash = a.getAttribute('href');
      if (hash.length <= 1) return;
      a.addEventListener('click', function (e) {
        var t = document.querySelector(hash);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        history.pushState(null, '', hash);
      });
    });

    /* Add body class so the CSS can hide legacy header/footer cleanly */
    document.body.classList.add('ed2026', 'ed-hide-legacy');
  });
})();
